import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import parameters from '../../../../../../config/parameters';

const PokerTable =({table, isLeague, currentTime}) => {
  const { t } = useTranslation();
  const isEndDateVisible = !isLeague && table.endDateAndTime;
    return (
        <div className={`pokerTable ${parameters.gameTypeTitles[table.gameType]}`}>
            <p className={`tableName`}>
                {table.description}
            </p>
            <div className="tableContent">
                <p className={`blinds`}>
                    {t('blinds')}:
                    <span className={'blindsChecker'}></span>
                    <span className={'smallBlind'}>{table.smallBlind}</span>/
                    <span className={'bigBlind'}>{table.bigBlind}</span>
                </p>
                <div className="secondRow">
                    <div className={'seats'}>
                        <div className={'persons'}></div>
                        <span className={'seatsActive'}>{table.seatsTaken}</span>/
                        <span className={'seatsQuantity'}>{table.seatsCount}</span>
                    </div>
                    {
                      isEndDateVisible && <span className={`time`}>
                        {
                          (Math.ceil(moment.duration(
                            moment(table.endDateAndTime).diff(moment())
                          ).asDays()) > 1) ?
                          <span>
                            {
                              Math.ceil(moment.duration(
                                moment(table.endDateAndTime).diff(moment())
                              ).asDays())
                            }d &nbsp;
                          </span> :
                          <span>
                            {
                              	moment.utc(new Date(moment(table.endDateAndTime)).getTime() - currentTime.getTime()).format("HH:mm:ss")
                            }
                          </span>
                        }
                      </span>
                    }
                </div>
            </div>
            {/* <div className={'limitType'}>
                <p className={'limitText'}>
                    { gameTypeTitles[table.gameType] }
                </p>
            </div> */}
        </div>
    );
};

export default PokerTable;
